module.exports = __webpack_public_path__ + "assets/img/btn-back-0ab420d0.png";